module.exports = __webpack_public_path__ + "assets/img/img186.2e4dd21b.png";